import { Chip } from '@mui/material';

export interface SepiaChipProps {
    label: string;
    active?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    /** Non-interactive outline chip (e.g. play type on event cards). */
    displayOnly?: boolean;
}

export const SepiaChip = ({
    label,
    active = false,
    onClick,
    disabled,
    displayOnly = false,
}: SepiaChipProps) => {
    if (displayOnly) {
        return (
            <Chip
                label={label}
                size="small"
                sx={{
                    height: 18,
                    backgroundColor: 'sepia.background',
                    color: 'sepia.main',
                    border: '1px solid',
                    borderColor: 'sepia.main',
                    fontFamily: 'Fredoka',
                    fontWeight: 400,
                    fontSize: 12,
                    cursor: 'default',
                    '& .MuiChip-label': { px: 1, py: 0 },
                    '&:hover': {
                        backgroundColor: 'sepia.background',
                    },
                }}
            />
        );
    }

    return (
        <Chip
            label={label}
            size="small"
            disabled={disabled}
            onClick={onClick}
            sx={{
                backgroundColor: active ? 'sepia.main' : 'transparent',
                color: active ? '#fff' : 'sepia.main',
                border: '1px solid',
                borderColor: active ? 'sepia.main' : 'sepia.extraLight',
                fontFamily: 'Fredoka',
                fontWeight: active ? 600 : 400,
                fontSize: '0.75rem',
                '&:hover': {
                    backgroundColor: active ? 'sepia.dark' : 'sepia.extraLight',
                    borderColor: active ? 'sepia.dark' : 'sepia.main',
                },
                '&.Mui-disabled': {
                    opacity: 0.4,
                },
            }}
        />
    );
};
